"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ptZones = exports.ptSubZoneNameMapping = void 0;
var ptZones = exports.ptZones = [{
  id: 'ALMADA',
  name: 'Almada',
  country: 'PT',
  cornerNW: {
    latitude: 38.6956,
    longitude: -9.1736
  },
  cornerSE: {
    latitude: 38.6456,
    longitude: -9.1136
  },
  subZones: [{
    name: 'Almada',
    zipcodes: {
      2800: {
        label: 'Almada'
      },
      2810: {
        label: 'Pragal'
      },
      2820: {
        label: 'Charneca da Caparica'
      },
      2825: {
        label: 'Costa da Caparica'
      },
      2830: {
        label: 'Barreiro'
      }
    }
  }]
}, {
  id: 'AMADORA',
  name: 'Amadora',
  country: 'PT',
  cornerNW: {
    latitude: 38.7689,
    longitude: -9.2489
  },
  cornerSE: {
    latitude: 38.7389,
    longitude: -9.2089
  },
  subZones: [{
    name: 'Amadora',
    zipcodes: {
      2700: {
        label: 'Amadora'
      },
      2720: {
        label: 'Damaia'
      },
      2650: {
        label: 'Alfragide'
      },
      2610: {
        label: 'Venda Nova'
      },
      2620: {
        label: 'Brandoa'
      }
    }
  }]
}, {
  id: 'AVEIRO',
  name: 'Aveiro',
  country: 'PT',
  cornerNW: {
    latitude: 40.6556,
    longitude: -8.6736
  },
  cornerSE: {
    latitude: 40.6056,
    longitude: -8.6136
  },
  subZones: [{
    name: 'Aveiro',
    zipcodes: {
      3800: {
        label: 'Aveiro'
      },
      3810: {
        label: 'São Bernardo'
      },
      3820: {
        label: 'Vera Cruz'
      },
      3830: {
        label: 'Glória'
      },
      3840: {
        label: 'Aradas'
      }
    }
  }]
}, {
  id: 'BRAGA',
  name: 'Braga',
  country: 'PT',
  cornerNW: {
    latitude: 41.5756,
    longitude: -8.4536
  },
  cornerSE: {
    latitude: 41.5256,
    longitude: -8.3936
  },
  subZones: [{
    name: 'Braga',
    zipcodes: {
      4700: {
        label: 'Braga'
      },
      4705: {
        label: 'São Vicente'
      },
      4710: {
        label: 'São Victor'
      },
      4715: {
        label: 'Maximinos'
      },
      4720: {
        label: 'Gualtar'
      }
    }
  }]
}, {
  id: 'COIMBRA',
  name: 'Coimbra',
  country: 'PT',
  cornerNW: {
    latitude: 40.2256,
    longitude: -8.4436
  },
  cornerSE: {
    latitude: 40.1756,
    longitude: -8.3836
  },
  subZones: [{
    name: 'Coimbra',
    zipcodes: {
      3000: {
        label: 'Coimbra'
      },
      3020: {
        label: 'Santa Clara'
      },
      3030: {
        label: 'Santo António dos Olivais'
      },
      3040: {
        label: 'Sé Nova'
      },
      3050: {
        label: 'São Bartolomeu'
      }
    }
  }]
}, {
  id: 'FUNCHAL',
  name: 'Funchal',
  country: 'PT',
  cornerNW: {
    latitude: 32.6656,
    longitude: -16.9436
  },
  cornerSE: {
    latitude: 32.6156,
    longitude: -16.8836
  },
  subZones: [{
    name: 'Funchal',
    zipcodes: {
      9000: {
        label: 'Funchal'
      },
      9020: {
        label: 'Monte'
      },
      9050: {
        label: 'São Martinho'
      },
      9060: {
        label: 'São Pedro'
      },
      9070: {
        label: 'Santa Luzia'
      }
    }
  }]
}, {
  id: 'LISBONNE',
  name: 'Lisbonne',
  country: 'PT',
  cornerNW: {
    latitude: 38.7964,
    longitude: -9.2290
  },
  cornerSE: {
    latitude: 38.6968,
    longitude: -9.0927
  },
  subZones: [{
    name: 'Alcântara',
    zipcodes: {
      1300: {
        label: 'Alcântara'
      }
    }
  }, {
    name: 'Alvalade',
    zipcodes: {
      1700: {
        label: 'Alvalade'
      }
    }
  }, {
    name: 'Areeiro',
    zipcodes: {
      1000: {
        label: 'Areeiro'
      }
    }
  }, {
    name: 'Arroios',
    zipcodes: {
      1150: {
        label: 'Arroios'
      }
    }
  }, {
    name: 'Avenidas Novas',
    zipcodes: {
      1050: {
        label: 'Avenidas Novas'
      }
    }
  }, {
    name: 'Beato',
    zipcodes: {
      1900: {
        label: 'Beato'
      }
    }
  }, {
    name: 'Belém',
    zipcodes: {
      1400: {
        label: 'Belém'
      }
    }
  }, {
    name: 'Benfica',
    zipcodes: {
      1500: {
        label: 'Benfica'
      }
    }
  }, {
    name: 'Campo de Ourique',
    zipcodes: {
      1350: {
        label: 'Campo de Ourique'
      }
    }
  }, {
    name: 'Campolide',
    zipcodes: {
      1070: {
        label: 'Campolide'
      }
    }
  }, {
    name: 'Lumiar',
    zipcodes: {
      1600: {
        label: 'Lumiar'
      }
    }
  }, {
    name: 'Marvila',
    zipcodes: {
      1950: {
        label: 'Marvila'
      }
    }
  }, {
    name: 'Misericórdia',
    zipcodes: {
      1200: {
        label: 'Misericórdia'
      }
    }
  }, {
    name: 'Olivais',
    zipcodes: {
      1800: {
        label: 'Olivais'
      }
    }
  }, {
    name: 'Parque das Nações',
    zipcodes: {
      1990: {
        label: 'Parque das Nações'
      }
    }
  }, {
    name: 'Penha de França',
    zipcodes: {
      1170: {
        label: 'Penha de França'
      }
    }
  }, {
    name: 'Santa Clara',
    zipcodes: {
      1750: {
        label: 'Santa Clara'
      }
    }
  }, {
    name: 'Santa Maria Maior',
    zipcodes: {
      1100: {
        label: 'Santa Maria Maior'
      }
    }
  }, {
    name: 'Santo António',
    zipcodes: {
      1250: {
        label: 'Santo António'
      }
    }
  }]
}, {
  id: 'PORTO',
  name: 'Porto',
  country: 'PT',
  cornerNW: {
    latitude: 41.1727,
    longitude: -8.6897
  },
  cornerSE: {
    latitude: 41.1094,
    longitude: -8.6119
  },
  subZones: [{
    name: 'Porto',
    zipcodes: {
      4000: {
        label: 'Santo Ildefonso, Sé'
      },
      4050: {
        label: 'Vitória, Miragaia'
      },
      4100: {
        label: 'Aldoar, Nevogilde'
      },
      4150: {
        label: 'Foz do Douro'
      },
      4200: {
        label: 'Paranhos'
      },
      4250: {
        label: 'Ramalde'
      },
      4300: {
        label: 'Campanhã'
      },
      4350: {
        label: 'Campanhã, Bonfim'
      }
    }
  }]
}, {
  id: 'SETUBAL',
  name: 'Setúbal',
  country: 'PT',
  cornerNW: {
    latitude: 38.5356,
    longitude: -8.9236
  },
  cornerSE: {
    latitude: 38.4856,
    longitude: -8.8636
  },
  subZones: [{
    name: 'Setúbal',
    zipcodes: {
      2900: {
        label: 'Setúbal'
      },
      2910: {
        label: 'Arrentela'
      },
      2920: {
        label: 'São Sebastião'
      },
      2930: {
        label: 'Nossa Senhora da Anunciada'
      },
      2940: {
        label: 'Santa Maria da Graça'
      }
    }
  }]
}, {
  id: 'VILA_NOVA_DE_GAIA',
  name: 'Vila Nova de Gaia',
  country: 'PT',
  cornerNW: {
    latitude: 41.1436,
    longitude: -8.6549
  },
  cornerSE: {
    latitude: 41.0789,
    longitude: -8.5726
  },
  subZones: [{
    name: 'Vila Nova de Gaia',
    zipcodes: {
      4400: {
        label: 'São Félix da Marinha'
      },
      4430: {
        label: 'Vila Nova de Gaia'
      },
      4415: {
        label: 'Carvalhos'
      },
      4405: {
        label: 'Canelas'
      },
      4410: {
        label: 'Arcozelo'
      }
    }
  }]
}];
var ptSubZoneNameMapping = exports.ptSubZoneNameMapping = [{
  old: 'Lisboa Baixa',
  "new": 'Areeiro'
}, {
  old: 'Lisboa Belém',
  "new": 'Misericórdia'
}, {
  old: 'Lisboa Alcântara',
  "new": 'Alcântara'
}, {
  old: 'Lisboa Graça',
  "new": 'Alvalade'
}];